/* blend — dynamic currency display.
   Pairs with Shopify Markets. Reads window.Shopify.currency (set by Shopify when
   Markets is enabled with non-shop currencies live) and re-renders any visible
   USD-coded price in the shopper's active currency with no decimals. */
(function () {
  var s = window.Shopify || {};
  var c = s.currency || {};
  var SEED = window.__blend_CURRENCY__ || {};

  var ACTIVE = c.active || SEED.active || 'USD';
  var RATE   = parseFloat(c.rate);
  if (!isFinite(RATE) || RATE <= 0) RATE = parseFloat(SEED.rate);
  if (!isFinite(RATE) || RATE <= 0) RATE = 1;

  var LOCALE = (navigator.language || 'en-US');

  function fmt(usdDollars) {
    var n = Math.round(usdDollars * RATE);
    try {
      return new Intl.NumberFormat(LOCALE, {
        style: 'currency',
        currency: ACTIVE,
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
      }).format(n);
    } catch (e) {
      return '$' + n;
    }
  }

  /* No-op when the page is already in shop currency (USD) at parity. */
  var IDENTITY = (ACTIVE === 'USD' && Math.abs(RATE - 1) < 0.0001);

  function scan(root) {
    root = root || document.body;
    if (!root) return;

    /* 1. Explicit spans — author-coded cents in USD. Convert even at parity so
          markup stays consistent. */
    var explicit = root.querySelectorAll('[data-money-usd]:not([data-money-done])');
    for (var i = 0; i < explicit.length; i++) {
      var el = explicit[i];
      var cents = parseInt(el.getAttribute('data-money-usd'), 10);
      if (isNaN(cents)) continue;
      el.textContent = fmt(cents / 100);
      el.setAttribute('data-money-done', '1');
    }

    if (IDENTITY) return;

    /* 2. Auto-scan — replace $N(,NNN)?(.NN)? patterns inside text nodes within
          [data-money-scan] regions. Skips subtrees marked [data-money-skip]. */
    var areas = root.querySelectorAll('[data-money-scan]:not([data-money-scanned])');
    if (!areas.length) return;

    var priceRe = /\$(\d{1,3}(?:,\d{3})*(?:\.\d+)?)/g;

    for (var j = 0; j < areas.length; j++) {
      var area = areas[j];
      area.setAttribute('data-money-scanned', '1');

      var walker = document.createTreeWalker(area, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) {
          if (!n.nodeValue || !/\$\d/.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
          var p = n.parentNode;
          while (p && p !== area) {
            if (p.nodeType === 1) {
              var tag = p.tagName;
              if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA') return NodeFilter.FILTER_REJECT;
              if (p.hasAttribute('data-money-skip')) return NodeFilter.FILTER_REJECT;
              if (p.hasAttribute('data-money-usd')) return NodeFilter.FILTER_REJECT;
            }
            p = p.parentNode;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      });

      var nodes = [], n;
      while ((n = walker.nextNode())) nodes.push(n);

      for (var k = 0; k < nodes.length; k++) {
        var node = nodes[k];
        node.nodeValue = node.nodeValue.replace(priceRe, function (_, num) {
          return fmt(parseFloat(num.replace(/,/g, '')));
        });
      }
    }
  }

  window.BlendMoney = {
    fmt: fmt,
    scan: scan,
    active: ACTIVE,
    rate: RATE,
    /* Force re-scan of a region after dynamic content insertion. */
    refresh: function (root) {
      if (root && root.removeAttribute) root.removeAttribute('data-money-scanned');
      scan(root);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
})();
